import get from 'immutable-less/transmute/get';
import { useQuery } from 'data-fetching-client';
import TeamsAssetAccessPanel from 'ui-asset-management-lib/components/TeamsAssetAccessPanel';
import { GET_HIERARCHICAL_TEAMS } from 'automation-ui-management/queries/assignableTeamsQueries';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const AllTeamAssetAccessPanel = ({
  assignedTeamIds,
  onSave,
  onCancel,
  showSaveLoading
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_HIERARCHICAL_TEAMS);
  return /*#__PURE__*/_jsx(TeamsAssetAccessPanel, {
    assetTypeDisplayName: I18n.text('automation-ui-management.workflow'),
    assignedTeamIds: assignedTeamIds,
    teams: get('assignableTeams', data) || [],
    onSave: onSave,
    onCancel: onCancel,
    requestsError: !!error,
    requestsLoading: loading,
    showSaveLoading: showSaveLoading
  });
};
export default AllTeamAssetAccessPanel;